import type {
  AddProfileCardData,
  GetUserInfoData,
  ProfileCard,
  RedirectResponse,
  UpdateProfileCardData,
} from '@/types/limbo.types.ts'
import axios from 'axios'
import { useCookies } from 'vue3-cookies'
import { baseUrl } from '@/constants/api.ts'
import { ProfileCardType } from '@/types/limbo.types.ts'

const urlPrefix = `${baseUrl}user/account/`

export const getProfileCards = async (type?: ProfileCardType): Promise<ProfileCard[]> => {
  let endpoint = ''

  switch (type) {
    case ProfileCardType.Guest:
      endpoint = 'profiles/?profile_type=external'

      break
    case ProfileCardType.Archive:
      endpoint = 'profiles/?status=archived'

      break
    case ProfileCardType.User:
      endpoint = 'profiles/?status=active&profile_type=own'

      break
    case ProfileCardType.All:
      endpoint = 'profiles/?status=active'

      break
    case undefined:
    default:
      endpoint = 'profiles'

      break
  }

  const res = await axios.get<{ data: ProfileCard[] }>(`${urlPrefix}${endpoint}`)

  return res.data.data
}

export const addProfileCard = async (data: AddProfileCardData): Promise<void> => {
  const { cookies } = useCookies()

  return axios.post(`${urlPrefix}profiles/`, data, {
    headers: {
      'X-CSRFToken': cookies.get('csrftoken'),
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const updateProfileCard = async (id: number, data: UpdateProfileCardData): Promise<void> => {
  const { cookies } = useCookies()

  return axios.post(`${urlPrefix}profiles/${id}/`, data, {
    headers: {
      'X-CSRFToken': cookies.get('csrftoken'),
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const archiveProfileCard = async (id: number, isArchive: boolean): Promise<void> => {
  const { cookies } = useCookies()

  const endpoint = isArchive ? `${urlPrefix}profiles/${id}/archive/` : `${urlPrefix}profiles/${id}/unarchive/`

  return axios.post(endpoint, null, {
    headers: {
      'X-CSRFToken': cookies.get('csrftoken'),
    },
  })
}

export const getUserInfo = async (): Promise<GetUserInfoData> => {
  const res = await axios.get<{ data: GetUserInfoData }>(`${urlPrefix}info/`)

  return res.data.data
}

export const updateUserInfo = async (data: GetUserInfoData): Promise<void> => {
  const { cookies } = useCookies()

  return axios.post(`${urlPrefix}info/`, data, {
    headers: {
      'X-CSRFToken': cookies.get('csrftoken'),
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const loginProfile = async (id: number): Promise<string> => {
  const { cookies } = useCookies()

  const { data } = await axios.post<RedirectResponse>(
    `${urlPrefix}profiles/${id}/login/`,
    {},
    {
      headers: {
        'X-CSRFToken': cookies.get('csrftoken'),
      },
    },
  )

  return data.data.redirect_url
}

export const logoutAccount = async (): Promise<string> => {
  const { cookies } = useCookies()

  const { data } = await axios.post<RedirectResponse>(
    `${urlPrefix}logout/`,
    {},
    {
      headers: {
        'X-CSRFToken': cookies.get('csrftoken'),
      },
    },
  )

  return data.data.redirect_url
}
